"use client"
import styled from "@emotion/styled"
import "swiper/css"
import { Container, NewText } from "ui"
import ImageWithAlt from "ui/ImageWithAlt"
import { extractImage, extractProperty } from "utils"

const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: black;
  margin: 22px 0 80px 0;
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`
const StyledContainer = styled.div`
  margin-top: 32px;
  background: white;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 40px;
  }
`
const StyledListItemContainer = styled.div`
  display: grid;
  grid-template-columns: 0.04fr 1fr;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`
const StyledDot = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.propBlue};
  margin-right: 16px;
  margin-left: 8px;
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`
type Props = {
  data: any
}

export const DocumentList: React.FC<Props> = ({ data }) => {
  const icon = extractImage(data, "icon")

  const title = extractProperty(data, "title")
  const documentListData = extractProperty(data, "documentList").map((i: any) => {
    return extractProperty(i, "documentName")
  })
  return (
    <Container>
      <StyledDivider />
      <StyledContainer>
        <ImageWithAlt image={icon} width={32} height={32} style={{ objectFit: "contain" }} />
        <NewText
          desktopFontSize={32}
          desktopFontWeight="400"
          desktopLineHeight="36px"
          mobileFontSize={24}
          mobileFontWeight="400"
          mobileLineHeight="28px"
          component="h1"
          color={"black"}
          marginBottom={"16px"}
        >
          {title}
        </NewText>
        {documentListData.map((i: string, k: number) => (
          <StyledListItemContainer key={k.toString()}>
            <StyledDot />
            <NewText
              desktopFontSize={18}
              desktopFontWeight="400"
              desktopLineHeight="100%"
              mobileFontSize={16}
              mobileFontWeight="400"
              mobileLineHeight={"20px"}
              component="div"
              color={"black"}
            >
              {i}
            </NewText>
          </StyledListItemContainer>
        ))}
        {/* <NewText
          desktopFontSize={18}
          desktopFontWeight="400"
          desktopLineHeight="100%"
          mobileFontSize={16}
          mobileFontWeight="400"
          mobileLineHeight={"20px"}
          component="div"
          color={"black"}
          dangerouslySetInnerHTML={{ __html: innerText }}
          maxWidth="800px"
          style={{ marginBlockStart: 16, marginBlockEnd: 40 }}
        /> */}
      </StyledContainer>
    </Container>
  )
}
export default DocumentList
